import { LoaderOptions } from '@googlemaps/js-api-loader';
import { LocationDTO } from '../../api/api';
import WorkClient from '../../api/workClient';

export const GoogleApiSettings: LoaderOptions = {
  apiKey: window._env_.MAPS_KEY,
  libraries: ['places'],
  id: 'My_ID'
};

interface AddressLike {
streetName?: string;
houseNumber?: string;
floor?: string | number;
door?: string;
postalCode?: string | number;
city?: string;
cityName?: string;
}

/**
 * Generic function to format any address-like object with street, house number, floor, door, postal code, and city.
 * Handles both LocationDTO and Address types, as well as objects with either 'city' or 'cityName'.
 */
export const formatAddress = (
  address?: AddressLike
): string => {
  if (!address) return '';
  
  const streetName = address.streetName ? address.streetName + ' ' : '';
  const houseNumber = address.houseNumber ?? '';
  const floor = address.floor ? ', ' + address.floor + '.' : '';
  const door = address.door ? ' ' + address.door : '';
  const addressPart = streetName + houseNumber + floor + door;
  const separator = addressPart ? ', ' : '';
  const postalCode = address.postalCode ? address.postalCode + ' ' : '';
  const city = address.city ?? address.cityName ?? '';
  return addressPart + separator + postalCode + city;
};

export const formatAddressIgnoreFloorAndDoor = (
  address?: AddressLike
): string => {
  if (!address) return '';
  return formatAddress({
    streetName: address.streetName,
    houseNumber: address.houseNumber,
    postalCode: address.postalCode,
    city: address.city ?? address.cityName,
  })
}

/**
 * Formats a LocationDTO as an address string.
 * @deprecated Use formatAddress instead for consistency
 */
export const getLocationString = (location: LocationDTO | undefined): string => {
  return formatAddress(location);
};

export const getNearestAddressByLatLng = async (
  coordinates: {
    lat: number;
    lng: number;
  }[]
): Promise<LocationDTO[]> => {
  const promises = [];
  const result: LocationDTO[] = [];

  for (let index = 0; index < coordinates.length; index++) {
    const { lat, lng } = coordinates[index];

    promises.push(
      WorkClient.getNearestAddress(lng, lat).then((obj) => {
        result.push({
          city: obj.supplerendebynavn ?? obj.postnummer.navn,
          houseNumber: obj.husnr,
          latitude: lat,
          longitude: lng,
          postalCode: obj.postnummer.nr,
          streetName: obj.vejstykke.navn
        });
      })
    );
  }

  return Promise.all(promises).then(() => {
    return result;
  });
};

export const locationsAreEqual = (a: LocationDTO, b: LocationDTO) => {
  return (
    a.streetName === b.streetName &&
    a.houseNumber === b.houseNumber &&
    a.floor === b.floor &&
    a.door === b.door &&
    a.postalCode === b.postalCode &&
    a.city === b.city &&
    a.latitude === b.latitude &&
    a.longitude === b.longitude
  );
};
